<app-avatar-generic (ValueSalida)="HanderOnChange($event)" [imgDisabled]="data.Reading" [name]="data.Campo" [UrlIMg]="value" (onDelete)="onDelete()" [resolutionImage]="resolutionImage"
[downloadImg]="data.DownloadImg!"></app-avatar-generic>
